<template>
    <div>
        <span>{{ $t('notification.formRestored', {
            user: $_.get(activity, 'actorUser.name'),
            formName: $_.get(activity, 'payload.formName'),
            formId: $_.get(activity, 'payload.formId')
        }) }}</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "FormRestored",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

